<template>
  <div class="wrapper">
    <Header class="header" data-title="공지사항"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content" class="bbs">
        <section>
          <div class="sortArea">
            <div class="lcont">
              <span class="txtM">
                <em>전체</em>
                (
                <span>{{ noticeListLength }}</span>
                )
              </span>
            </div>
          </div>

          <ul class="bbsList">
            <li v-for="(notice, noticeIndex) in noticeList" :key="noticeIndex">
              <a href="javascript:void(0);" @click="goNoticeDetail(notice.noticeIndex)">
                <div class="tit" v-text="notice.title"></div>
                <div class="infoGroup">
                  <span class="date">
                    <span class="blind">게시일자</span>
                    {{ notice.noticeDate }}
                  </span>
                  <!-- <span class="count"><span class="blind">조회수</span>508</span> -->
                </div>
              </a>
            </li>
            <infinite-loading spinner="circles" @infinite="infiniteHandler" v-show="p_flag == 'Y'" />
          </ul>
          <div class="paging"></div>
        </section>
      </div>
      <!-- content(e) -->
      <QuickMenu></QuickMenu>
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
//import * as customjs from '../../../../static/js/m.front.js';
import QuickMenu from '@/views/app/comm/QuickMenu';
import ApiService from '@/common/api.service';
import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: 'customerCenterNotice',
  components: {
    InfiniteLoading,
    QuickMenu,
  },
  data: function() {
    return {
      noticeList: [],
      noticeListLength: 0,

      //페이징 관련
      loadingState: null,
      maxPage: null,
      p_flag: 'Y',
      initFlag: 'N',
      page: 1,
    };
  },
  mounted() {
    //
  },
  methods: {
    infiniteHandler: function($state) {
      this.loadingState = $state;
      console.log(this.maxPage + 'page:' + this.page); // page No
      if (this.maxPage < this.page && this.maxPage != null) {
        this.p_flag = 'N';
        return false;
      }
      let paramObj = new Object();
      paramObj.size = 10;
      paramObj.page = this.page;
      paramObj.filter = '';
      paramObj.direction = '';

      ApiService.service('GET', '/board/notice?direction=DESC&page=' + this.page)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.maxPage = data.result.totalPages;
            this.noticeListLength = data.result.totalElements;

            for (let notice of data.result.content) {
              this.noticeList.push(notice);
            }

            this.page++;
            $state.loaded();
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    goNoticeDetail: function(noticeIndex) {
      this.$router.push({ name: 'customerCenterNoticeDetail', params: { idx: noticeIndex } });
    },
  },
};
</script>
